export function absCeil(number) {
    return number < 0 ? Math.floor(number) : Math.ceil(number);
}
//# sourceMappingURL=abs-ceil.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/chronos/utils/abs-ceil.js
// module id = ../../../../ngx-bootstrap/chronos/utils/abs-ceil.js
// module chunks = 4